<template>
  <v-container class="my-n2" fluid>
    <v-card>
      <v-card-title>
        <div class="d-flex flex-wrap align-center">
          <span class="mr-2">
            <v-icon color="primary">mdi-file-document-multiple-outline</v-icon>

            Documentos de Inscripciones
          </span>

          <v-switch
            class="mt-0"
            v-model="agrupadoPorInscripcion"
            label="Agrupado por Inscripción"
            dense
            hide-details
            :disabled="cargando"
            @change="
              () => {
                pagina = 1;

                establecerEstaAgrupadoEnLocalStorage();

                cargarDatos();
              }
            "></v-switch>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" md="6" lg="4">
            <v-select
              v-model="filtros.categoriasIds"
              :items="categorias"
              label="Categorías"
              item-value="id"
              item-text="nombre"
              multiple
              dense
              outlined
              clearable
              small-chips
              hide-details
              @change="cambiadoCategoriasIds">
              <template v-slot:[`item`]="{ item }">
                <v-list-item-icon>
                  <v-icon v-if="filtros.categoriasIds.includes(item.id)" color="primary"> mdi-checkbox-marked </v-icon>

                  <v-icon v-else> mdi-checkbox-blank-outline </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>

                  <v-list-item-subtitle>{{ item.unidadNegocio.nombre }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>

              <template v-slot:[`selection`]="{ item, index }">
                <v-chip
                  :key="index"
                  class="ma-1"
                  color="grey"
                  small
                  dark
                  close
                  @click:close="
                    () => {
                      filtros.categoriasIds.splice(index, 1);

                      cambiadoCategoriasIds();
                    }
                  ">
                  {{ item.nombre }}
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="3">
            <v-select
              v-model="filtros.propositos"
              :items="propositos"
              label="Propósitos"
              multiple
              dense
              outlined
              clearable
              small-chips
              hide-details
              @change="cambiadoPropositos">
              <template v-slot:[`selection`]="{ item, index }">
                <v-chip
                  :key="index"
                  class="ma-1"
                  small
                  dark
                  close
                  @click:close="
                    () => {
                      filtros.propositos.splice(index, 1);

                      cambiadoPropositos();
                    }
                  ">
                  {{ item.value }}
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="5">
            <v-select
              v-model="filtros.tiposDocumentosIds"
              :items="tiposDocumentosPersonasFiltrados"
              label="Tipos Documentos Personas"
              item-value="id"
              item-text="nombre"
              multiple
              dense
              outlined
              clearable
              small-chips
              hide-details
              @change="establecerTiposDocumentosEnLocalStorage">
              <template v-slot:[`item`]="{ item }">
                <v-list-item-icon>
                  <v-icon v-if="filtros.tiposDocumentosIds.includes(item.id)" color="primary">
                    mdi-checkbox-marked
                  </v-icon>

                  <v-icon v-else> mdi-checkbox-blank-outline </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>

                  <v-list-item-subtitle>{{ item.proposito }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>

              <template v-slot:[`selection`]="{ item, index }">
                <v-chip
                  :key="index"
                  :color="getEstadoRevisionColor(item)"
                  class="ma-1"
                  small
                  dark
                  close
                  @click:close="
                    () => {
                      filtros.tiposDocumentosIds.splice(index, 1);

                      establecerTiposDocumentosEnLocalStorage();
                    }
                  ">
                  {{ item.nombre }}
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4">
            <v-select
              v-model="filtros.estadosRevision"
              :items="estadosRevisionOptions"
              label="Estados Revisión"
              multiple
              dense
              outlined
              clearable
              small-chips
              hide-details
              @change="establecerEstadosRevisionEnLocalStorage">
              <template v-slot:[`selection`]="{ item, index }">
                <v-chip
                  :key="index"
                  :color="getEstadoRevisionColor(item)"
                  class="ma-1"
                  small
                  dark
                  close
                  @click:close="
                    () => {
                      filtros.estadosRevision.splice(index, 1);

                      establecerEstadosRevisionEnLocalStorage();
                    }
                  ">
                  {{ item }}
                </v-chip>
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4">
            <v-text-field
              v-model="filtros.programaId"
              type="number"
              min="1"
              step="1"
              label="ID. del Programa"
              placeholder="Ingrese ID del programa"
              dense
              outlined
              clearable
              hide-details
              @input="establecerProgramaIdEnLocalStorage"></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4">
            <v-text-field
              v-model="filtros.codigoProgramaUniversidad"
              type="text"
              label="Código del Programa Universidad"
              placeholder="Ingrese código del programa universidad"
              dense
              outlined
              clearable
              hide-details
              @input="establecerCodigoProgramaUniversidadEnLocalStorage"></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4">
            <div class="d-flex align-center">
              <v-text-field
                v-model="filtros.busqueda"
                label="Búsqueda"
                placeholder="Ingrese términos de búsqueda"
                dense
                outlined
                clearable
                hide-details
                @input="establecerBusquedaEnLocalStorage">
                <template v-slot:prepend-inner>
                  <v-tooltip bottom max-width="400">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="grey"> mdi-help-circle-outline </v-icon>
                    </template>
                    <span> Búsqueda posible por el número de documento, nombres o apellidos del estudiante </span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="3">
            <div class="d-flex align-center">
              <v-checkbox
                v-model="filtros.incluirEliminados"
                label="Incluir Reemplazados"
                dense
                hide-details
                @change="
                  () => {
                    pagina = 1;

                    cargarDatos();

                    establecerIncluirEliminadosEnLocalStorage();
                  }
                "></v-checkbox>

              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" color="grey"> mdi-help-circle-outline </v-icon>
                </template>

                <span>
                  Al activar "Incluir Reemplazados", se mostrarán también los documentos que han sido eliminados
                  (reemplazados) en las inscripciones. Estos documentos aparecerán con un fondo rojo para diferenciarlos
                  claramente.
                </span>
              </v-tooltip>
            </div>
          </v-col>

          <v-col cols="12" sm="12" md="12" lg="5">
            <v-btn
              class="ma-1"
              color="primary"
              @click="
                () => {
                  pagina = 1;

                  cargarDatos();
                }
              "
              :disabled="cargando"
              :loading="cargando">
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-1"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="descargandoExcel"
                  :loading="descargandoExcel">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item link>
                  <v-list-item-title @click="descargarExcel(false)"> Documentos de Inscripción </v-list-item-title>
                </v-list-item>

                <v-list-item link>
                  <v-list-item-title @click="descargarExcel(true)">
                    Documentos Agrupados por Inscripción
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-btn
              class="ma-1"
              color="success"
              :disabled="descargandoReporteExcel"
              :loading="descargandoReporteExcel"
              @click="descargarReporteExcel">
              <v-icon left>mdi-file-excel</v-icon>

              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on"> Reporte </span>
                </template>

                <span>
                  Los unicos filtros que se aplican al descargar el reporte son los de propósitos, id de programa,
                  código de programa universidad y búsqueda.
                </span>
              </v-tooltip>
            </v-btn>

            <v-tooltip bottom max-width="400">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn
                    class="ma-1"
                    color="success"
                    :disabled="descargandoConDatosExcel || filtros.tiposDocumentosIds.length !== 1"
                    :loading="descargandoConDatosExcel"
                    @click="descargarConDatosExcel">
                    <v-icon left>mdi-file-excel</v-icon>
                    Con Datos
                  </v-btn>
                </span>
              </template>
              <span>
                Descarga el Excel con datos completos del documento seleccionado. Solo disponible cuando se selecciona
                exactamente un tipo de documento.
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-text>

      <DataTableDocumentosInscripciones
        v-if="!agrupadoPorInscripcion"
        :documentos="documentos"
        :cargando="cargando"
        :total-items="totalItems"
        :pagina.sync="pagina"
        :items-por-pagina.sync="itemsPorPagina"
        @cargar-datos="cargarDatos"
        @actualizar-items-por-pagina="actualizarItemsPorPagina" />

      <DataTableDocumentosInscripcionesAgrupado
        v-else
        :documentos="documentos"
        :cargando="cargando"
        :total-items="totalItems"
        :pagina.sync="pagina"
        :items-por-pagina.sync="itemsPorPagina"
        @cargar-datos="cargarDatos"
        @actualizar-items-por-pagina="actualizarItemsPorPagina"
        @actualizar-lista="cargarDatos" />
    </v-card>

    <notifications group="notifications" position="top right" />
  </v-container>
</template>

<script>
import categoriasService from '../../comisiones/services/categorias.service';
import inscripcionesDocumentosPersonasService from '../../comisiones/services/inscripciones-documentos-personas.service';
import requisitosDocumentalesService from '../../comisiones/services/requisitos-documentales.service';
import { PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_ARRAY } from '../../comisiones/utils/constantes';
import { ESTADOS_REVISION_DOCUMENTO_INSCRIPCION } from './utils';
import DataTableDocumentosInscripciones from './components/DataTableDocumentosInscripciones.vue';
import DataTableDocumentosInscripcionesAgrupado from './components/DataTableDocumentosInscripcionesAgrupado.vue';
import { mapGetters } from 'vuex';
import inscripcionesDocumentosPersonasExcelService from '../../comisiones/services/inscripciones-documentos-personas-excel.service';

export const UNIDAD_NEGOCIO_ID_ESAM = 1;
export const UNIDAD_NEGOCIO_ID_ESAM_LATAM = 5;

export default {
  name: 'DocumentosInscripciones',
  components: {
    DataTableDocumentosInscripciones,
    DataTableDocumentosInscripcionesAgrupado,
  },
  data() {
    return {
      propositos: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA_ARRAY,
      documentos: [],
      cargando: false,
      pagina: 1,
      itemsPorPagina: JSON.parse(localStorage.getItem('documentosInscripcionesItemsPorPagina')) || 10,
      totalItems: 0,
      filtros: {
        propositos: JSON.parse(localStorage.getItem('documentosInscripcionesPropositos')) || [],
        tiposDocumentosIds: JSON.parse(localStorage.getItem('documentosInscripcionesTiposDocumentosIds')) || [],
        estadosRevision: JSON.parse(localStorage.getItem('documentosInscripcionesEstadosRevision')) || [],
        categoriasIds: [],
        busqueda: JSON.parse(localStorage.getItem('documentosInscripcionesBusqueda')) || null,
        sedesIds: [],
        programaId: JSON.parse(localStorage.getItem('documentosInscripcionesProgramaId')) || null,
        codigoProgramaUniversidad:
          JSON.parse(localStorage.getItem('documentosInscripcionesCodigoProgramaUniversidad')) || null,
        incluirEliminados: JSON.parse(localStorage.getItem('documentosInscripcionesIncluirEliminados')) || false,
      },
      estadosRevisionOptions: Object.values(ESTADOS_REVISION_DOCUMENTO_INSCRIPCION),
      categorias: [],
      categoriasIds: [],
      tiposDocumentosIds: [],
      requisitosDocumentales: [],
      agrupadoPorInscripcion:
        JSON.parse(localStorage.getItem('documentosInscripcionesAgrupadoPorInscripcion')) || false,
      descargandoExcel: false,
      descargandoReporteExcel: false,
      descargandoConDatosExcel: false,
    };
  },
  mounted() {
    this.cargarRequisitosDocumentales();
    this.cargarDatos();
  },
  computed: {
    unidadesNegociosIds() {
      const unidadNegocioId = this.$store.state.CARGO.sede.unidad_negocio;

      return [UNIDAD_NEGOCIO_ID_ESAM, UNIDAD_NEGOCIO_ID_ESAM_LATAM].includes(unidadNegocioId)
        ? [UNIDAD_NEGOCIO_ID_ESAM, UNIDAD_NEGOCIO_ID_ESAM_LATAM]
        : [unidadNegocioId];
    },
    tiposDocumentosPersonasFiltrados() {
      let requisitosDocumentales = this.requisitosDocumentales;

      if (this.filtros.categoriasIds?.length > 0) {
        requisitosDocumentales = requisitosDocumentales.filter((req) =>
          this.filtros.categoriasIds.includes(req.categoriaId),
        );
      }

      if (this.filtros.propositos?.length > 0) {
        requisitosDocumentales = requisitosDocumentales.filter((req) =>
          this.filtros.propositos.includes(req.tipoDocumentoPersona.proposito),
        );
      }

      return requisitosDocumentales.map((req) => req.tipoDocumentoPersona);
    },
    ...mapGetters({
      permisosDNA: 'comision/permisosDNA',
    }),
  },
  watch: {
    '$store.state.CARGO.sede.unidad_negocio': {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.cargarCategorias();
        }
      },
      immediate: true,
    },
    '$store.state.CARGO.sede.id': {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.filtros.sedesIds = newVal ? [newVal] : [];

          this.pagina = 1;

          this.cargarDatos();
        }
      },
      immediate: true,
    },
  },
  methods: {
    obtenerParametros() {
      const params = {
        pagina: this.pagina,
        itemsPorPagina: this.itemsPorPagina,
      };

      if (this.filtros.estadosRevision && this.filtros.estadosRevision.length > 0) {
        params.estadosRevision = this.filtros.estadosRevision.join(',');
      }

      if (this.filtros.categoriasIds && this.filtros.categoriasIds.length > 0) {
        params.categoriasIds = this.filtros.categoriasIds.join(',');
      }

      if (this.filtros.propositos && this.filtros.propositos.length > 0) {
        params.propositos = this.filtros.propositos.join(',');
      }

      if (this.filtros.tiposDocumentosIds && this.filtros.tiposDocumentosIds.length > 0) {
        params.tiposDocumentosIds = this.filtros.tiposDocumentosIds.join(',');
      }

      if (this.filtros.busqueda) {
        params.busqueda = this.filtros.busqueda;
      }

      if (this.filtros.sedesIds && this.filtros.sedesIds.length > 0 && !this.permisosDNA) {
        params.sedesIds = this.filtros.sedesIds.join(',');
      }

      if (this.filtros.programaId) {
        params.programasIds = `${this.filtros.programaId}`;
      }

      if (this.filtros.codigoProgramaUniversidad) {
        params.codigosProgramasUniversidades = `${this.filtros.codigoProgramaUniversidad}`;
      }

      if (this.filtros.incluirEliminados) {
        params.incluirEliminados = true;
      }

      return params;
    },
    async cargarDatos() {
      this.documentos = [];
      this.cargando = true;

      const params = this.obtenerParametros();
      const servicio = this.agrupadoPorInscripcion
        ? inscripcionesDocumentosPersonasService.findAllAgrupado
        : inscripcionesDocumentosPersonasService.findAll;

      try {
        const response = await servicio({ params });
        const data = response.data;
        const datos = data.datos || [];
        const mensaje = data.mensaje || 'Datos cargados correctamente';

        this.documentos = datos;
        this.totalItems = response.data.metadatos.totalItems;
        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje,
          type: 'success',
        });
      } catch (error) {
        window.console.error('Error al cargar documentos:', error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al cargar los documentos de inscripciones.',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    async cargarCategorias() {
      try {
        const params = {
          unidadesNegociosIds: this.unidadesNegociosIds.join(','),
        };
        const response = await categoriasService.findAll({ params });

        this.categorias = response.data.datos;
      } catch (error) {
        window.console.error('Error al cargar categorías:', error);
      }
    },
    async cargarRequisitosDocumentales() {
      try {
        const response = await requisitosDocumentalesService.findAll();

        this.requisitosDocumentales = response.data.datos;
      } catch (error) {
        window.console.error('Error al cargar requisitos documentales:', error);
      }
    },
    getEstadoRevisionColor(estado) {
      const colores = {
        pendiente: 'orange',
        aprobado: 'success',
        rechazado: 'error',
      };

      return colores[estado] || 'grey';
    },
    formatearFecha(fecha) {
      if (!fecha) {
        return '';
      }

      return new Date(fecha).toLocaleString('es-BO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    establecerEstaAgrupadoEnLocalStorage() {
      localStorage.setItem(
        'documentosInscripcionesAgrupadoPorInscripcion',
        JSON.stringify(this.agrupadoPorInscripcion),
      );
    },
    establecerPropositosEnLocalStorage() {
      localStorage.setItem('documentosInscripcionesPropositos', JSON.stringify(this.filtros.propositos));
    },
    establecerTiposDocumentosEnLocalStorage() {
      localStorage.setItem(
        'documentosInscripcionesTiposDocumentosIds',
        JSON.stringify(this.filtros.tiposDocumentosIds),
      );
    },
    establecerEstadosRevisionEnLocalStorage() {
      localStorage.setItem('documentosInscripcionesEstadosRevision', JSON.stringify(this.filtros.estadosRevision));
    },
    establecerBusquedaEnLocalStorage() {
      localStorage.setItem('documentosInscripcionesBusqueda', JSON.stringify(this.filtros.busqueda));
    },
    establecerProgramaIdEnLocalStorage() {
      localStorage.setItem('documentosInscripcionesProgramaId', JSON.stringify(this.filtros.programaId));
    },
    establecerCodigoProgramaUniversidadEnLocalStorage() {
      localStorage.setItem(
        'documentosInscripcionesCodigoProgramaUniversidad',
        JSON.stringify(this.filtros.codigoProgramaUniversidad),
      );
    },
    actualizarItemsPorPagina(nuevoItemsPorPagina) {
      localStorage.setItem('documentosInscripcionesItemsPorPagina', JSON.stringify(nuevoItemsPorPagina));

      this.cargarDatos();
    },
    establecerIncluirEliminadosEnLocalStorage() {
      localStorage.setItem('documentosInscripcionesIncluirEliminados', JSON.stringify(this.filtros.incluirEliminados));
    },
    cambiadoCategoriasIds() {
      this.filtros.tiposDocumentosIds = [];

      this.establecerTiposDocumentosEnLocalStorage();
    },
    cambiadoPropositos() {
      this.filtros.tiposDocumentosIds = [];

      this.establecerPropositosEnLocalStorage();
      this.establecerTiposDocumentosEnLocalStorage();
    },
    async descargarExcel(agrupado = false) {
      this.descargandoExcel = true;

      try {
        const params = this.obtenerParametros();
        const servicio = agrupado
          ? inscripcionesDocumentosPersonasExcelService.findAllAgrupado
          : inscripcionesDocumentosPersonasExcelService.findAll;
        const response = await servicio({ params });
        const headers = response.headers;
        const data = response.data;
        const disposition = headers['content-disposition'];
        const filenameMatch = disposition && disposition.match(/filename="?([^"]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : 'documentos_inscripciones.xlsx';
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'El archivo Excel se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        window.console.error('Error al descargar Excel:', error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al descargar el archivo Excel.',
          type: 'error',
        });
      } finally {
        this.descargandoExcel = false;
      }
    },
    async descargarReporteExcel() {
      if (!this.filtros.programaId && !this.filtros.codigoProgramaUniversidad && !this.filtros.busqueda) {
        this.$notify({
          group: 'notifications',
          title: 'Advertencia',
          text: 'Para descargar el reporte Excel, es necesario ingresar el ID del programa, el código del programa universidad o un término de búsqueda. Debido al tamaño potencialmente grande del reporte, es necesario aplicar al menos uno de estos filtros para limitar la cantidad de datos descargados y evitar errores',
          type: 'warning',
        });

        return;
      }

      this.descargandoReporteExcel = true;

      try {
        const params = this.obtenerParametros();
        const response = await inscripcionesDocumentosPersonasExcelService.reporteDocumentos({ params });
        const headers = response.headers;
        const data = response.data;
        const disposition = headers['content-disposition'];
        const filenameMatch = disposition && disposition.match(/filename="?([^"]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : 'reporte_documentos_inscripciones.xlsx';
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'El reporte Excel se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        window.console.error('Error al descargar reporte Excel:', error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al descargar el reporte Excel.',
          type: 'error',
        });
      } finally {
        this.descargandoReporteExcel = false;
      }
    },
    async descargarConDatosExcel() {
      if (this.filtros.tiposDocumentosIds.length !== 1) {
        this.$notify({
          group: 'notifications',
          title: 'Advertencia',
          text: 'Para descargar el Excel con datos completos, es necesario seleccionar exactamente un tipo de documento. Esto se debe a que el archivo contiene información detallada que solo puede ser generada para un tipo de documento a la vez.',
          type: 'warning',
        });

        return;
      }

      this.descargandoConDatosExcel = true;

      try {
        const params = this.obtenerParametros();
        const tipoDocumentoPersonaId = this.filtros.tiposDocumentosIds[0];

        params.tipoDocumentoPersonaId = tipoDocumentoPersonaId;

        const response = await inscripcionesDocumentosPersonasExcelService.findAllConDatos({ params });
        const headers = response.headers;
        const data = response.data;
        const disposition = headers['content-disposition'];
        const filenameMatch = disposition && disposition.match(/filename="?([^"]+)"?/);
        const filename = filenameMatch ? filenameMatch[1] : 'documentos_inscripciones_con_datos.xlsx';
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: 'El archivo Excel con datos se ha descargado correctamente.',
          type: 'success',
        });
      } catch (error) {
        window.console.error('Error al descargar Excel con datos:', error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al descargar el archivo Excel con datos.',
          type: 'error',
        });
      } finally {
        this.descargandoConDatosExcel = false;
      }
    },
  },
};
</script>